import React, { createContext, useContext, useState } from 'react';
import Toast from '../components/Toast';

const ToastContext = createContext();

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
};

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const addToast = (toast) => {
    const id = Date.now() + Math.random();
    const newToast = {
      id,
      ...toast,
      isOpen: true
    };
    
    setToasts(prev => [...prev, newToast]);
    return id;
  };

  const removeToast = (id) => {
    setToasts(prev => prev.filter(toast => toast.id !== id));
  };

  const showSuccess = (message, title = 'Success!', duration = 5000) => {
    return addToast({
      type: 'success',
      title,
      message,
      duration
    });
  };

  const showError = (message, title = 'Error!', duration = 8000) => {
    return addToast({
      type: 'error',
      title,
      message,
      duration
    });
  };

  const showWarning = (message, title = 'Warning!', duration = 6000) => {
    return addToast({
      type: 'warning',
      title,
      message,
      duration
    });
  };

  const showInfo = (message, title = 'Info', duration = 5000) => {
    return addToast({
      type: 'info',
      title,
      message,
      duration
    });
  };

  const clearAllToasts = () => {
    setToasts([]);
  };

  const value = {
    addToast,
    removeToast,
    showSuccess,
    showError,
    showWarning,
    showInfo,
    clearAllToasts
  };

  return (
    <ToastContext.Provider value={value}>
      {children}
      {toasts.map((toast, index) => {
        const bottomPosition = 20 + (index * 80);
        return (
          <div
            key={toast.id}
            style={{
              position: 'fixed',
              bottom: `${bottomPosition}px`,
              right: '20px',
              zIndex: 9999 + index
            }}
          >
            <Toast
              {...toast}
              onClose={() => removeToast(toast.id)}
            />
          </div>
        );
      })}
    </ToastContext.Provider>
  );
};
